<template>
  <DialogVue
    :header="'¿Seguro que quiere regresar este oficio?'"
    :visible="true"
    :modal="true"
    :closable="false"
    class="flex align-items-center justify-content-center surface-0 shadow-8"
    :breakpoints="{ '1560px': '75vw', '640px': '90vw' }"
    :style="{ width: width >= 900 ? '50vw' : '95%' }"
  >
    <div
      class="grid mb-6"
      style="padding: 0px; margin: 0px"
      :style="{ fontSize: width < 425 ? '0.7rem' : '1rem' }"
    >

      <div
        class="col-12 mb-3 fixed-top flex align-items-center justify-content-end"
        style="padding: 0px; margin: 30px; margin-top: -8px; min-width: none"
      >
        <ButtonVue
          icon="fa-solid fa-xmark"
          @click="toggleDialog"
          class="p-button-rounded p-button-text p-button-secondary"
        />
      </div>

      <div
        class="col-12 mt-3 fixed-bottom flex align-items-center justify-content-center"
      >
        <ButtonVue
          label="Regresar oficio"
          icon="fa-solid fa-rotate-left"
          class="botonGobColorVB scalein animation-duration-1000"
          @click="regresarOficioAction()"
        />
      </div>
    </div>
  </DialogVue>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import useOpenDialogs from "../../composables/useOpenDialogs";
import Swal from "sweetalert2";
import useOficiosCreacion from "../../composables/useOficiosCreacion"

export default {
  emits: ['valor', 'desde'],
  props: {
    desde: {
      type: String,
      required: false // o true si quieres obligarlo
    }
  },
  setup(props, {emit}) {
    const { toggleDialog, oficioRegresar } = useOpenDialogs();
    const {regresarOficio} = useOficiosCreacion()
    
    // const { altaLeyenda, getLeyendas } = useLeyendas();

    const regresarOficioAction = async () => {      
      let formData = new FormData();
      formData.append("idOficio", oficioRegresar.value.idOficio);
        new Swal({
          title: "Cargando...",
          text: "Regresando Oficio a fase de creación",
          allowOutsideClick: false,
        });
        Swal.showLoading();
        await regresarOficio(formData,props.desde)
        emit('valor');

          toggleDialog();
       
    };

    // --- Dimensiones de la pantalla (Ancho) ---
    const width = ref(window.innerWidth);

    const actualizarDimensiones = () => {
      width.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", actualizarDimensiones);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", actualizarDimensiones);
    });
    // -----------------------------------------

    return {
      toggleDialog,
      useOpenDialogs,
      width,
      oficioRegresar,
      regresarOficio,
      regresarOficioAction
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep(.tabsTablas) {
  .p-tabview-nav {
    font-size: 13px;
  }
}

.buttonDialog {
  color: gray;
}

.p-button {
  margin: 0.3rem 0.5rem;
  min-width: 10rem;
}

p {
  margin: 0;
}

/* Botones para Confirmacion */
::v-deep(.botonGobColor) {
  background-color: #4a001f;
  border-color: #4a001f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

::v-deep(.botonGobColor:hover) {
  background-color: #80245f;
  border-color: #80245f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-dialog .p-button {
  min-width: 6rem;
}

.gobcolor1 {
  color: #ffff;
  background-color: #4a001f;
}

.gobcolor1:hover {
  color: #ffff;
  background-color: #80245f;
}

/* Clases para las Chips de Asistentes */
::v-deep(.vistobuenochip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

.vistobuenochip {
  color: #53bdeb;
  background: #005c4b;
}

::v-deep(.concopiaparachip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

.concopiaparachip {
  color: #8e9497;
  background: #005c4b;
}

::v-deep(.firmantechip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

::v-deep(.firmantechipMenu) {
  .p-chip-text {
    font-size: 13px;
  }
}

.firmantechip {
  color: yellow;
  background: #005c4b;
}

::v-deep(.enviadoparachip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

::v-deep(.enviadoparachipMenu) {
  .p-chip-text {
    font-size: 13px;
  }
}

.enviadoparachip {
  color: rgb(133, 255, 225);
  background: #005c4b;
}

::v-deep(.atencionparachip) {
  .p-chip-text {
    color: white;
    font-size: 13px;
  }
}

.atencionparachip {
  color: rgb(255, 144, 80);
  background: #005c4b;
}

.fondoparachips {
  background: #0b141a;
}

/* Clases para las Chips de Asistentes */

::v-deep(.asistentestable) {
  .p-datatable {
    color: white;
    background: #0b141a;

    .p-column-title {
      color: white;
      background: #0b141a;
    }
  }
}

::v-deep(.botonasistentes) {
  .p-button-label {
    font-size: 12px;
  }
}

.botonasistentes {
  color: white;
  background: #005c4b;
}

.fondoasistentes {
  background: #202c33;
}

.fondoasistentes2 {
  background: #2a3942;
}

.textotab {
  font-size: 13px;
}

.datosOficioEncabezado {
  color: grey;
  font-size: 12px;
}

.datosOficioEncabezadoContenido {
  color: black;
  font-size: 15px;
}

.datosOficioEncabezadoContenido2 {
  font-weight: bold;
  color: black;
  font-size: 15px;
}

.datosOficioEncabezadoContenido3 {
  color: black;
  font-size: 12px;
}

.coloraux1 {
  background: rgb(209, 165, 19);
  font-weight: lighter;
}

.coloraux2 {
  background: rgb(92, 92, 92);
  font-weight: lighter;
}

.coloraux3 {
  background: #4a001f;
  font-weight: lighter;
}

// Estilos del formulario
::v-deep(.inputGenerales) {
  padding-top: 1px;
  padding-bottom: 1px;
  font-size: 13px;
  font-weight: bold;
}

::v-deep(.dropDownVistas) {
  .p-dropdown-label {
    color: black;
    font-size: 13px;
    font-weight: bold;
  }

  .p-dropdown-trigger {
    display: none;
  }
}

.leyendaDocumento {
  color: black;
  opacity: 0.9;
  font-size: 25px;
}

::v-deep(.inputGeneralesCalendar) {
  .p-inputtext {
    color: black;
    font-size: 13px;
    font-weight: bold;
  }
}

::v-deep(.editorCuerpo) {
  .p-editor-content {
    background: rgba(0, 0, 0, 0.5);
    color: black;
    font-size: 18px;
  }
}
</style>
